export default __webpack_public_path__ + "static/media/285hz-Immune-System-Booster.43550f01.mp3";